import "./DownChevron.scss";

const DownChevron = () => {
    return (
        <span className="down-chevron">&raquo;</span>
    )
}

export default DownChevron;